import React from "react";
import styled from "styled-components";
import config from "../../../../../config/customers";
import { ContainerCss, Devices } from "../../styles";
import Link from "./components/Link";
import LinkContainer from "./components/Link/LinkContainer";
import Text from "./components/Text";

const StyledFooter = styled.footer`
  ${ContainerCss};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: #eeeeee;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  @media ${Devices.desktop} {
    padding-top: 1.5rem;
    padding-bottom: 2.75rem;
  }
`;

const {
  publicPortal: { footerSection: FOOTER_SECTION },
} = config;

const TextsSection = () => {
  const renderText = (footerText, index) => {
    return <Text key={`footer_text_${index}`}>{footerText}</Text>;
  };

  return <>{FOOTER_SECTION.texts.map(renderText)}</>;
};

const LinksSection = () => {
  const renderLink = ({ text, url, external }, index) => {
    return (
      <Link key={`footer_link_${index}`} to={url} external={external}>
        {text}
      </Link>
    );
  };
  return <LinkContainer>{FOOTER_SECTION.links.map(renderLink)}</LinkContainer>;
};

const FooterSection = () => {
  const hasLinks = FOOTER_SECTION.links.length > 0;
  return (
    <StyledFooter>
      <TextsSection />
      {hasLinks && <LinksSection />}
    </StyledFooter>
  );
};

export default FooterSection;
